module.exports = __webpack_public_path__ + "media/images/rank/gold-md-54302889c3a8eb34900322913abd74c3.svg";